let klaviyoPopupTriggers = document.querySelectorAll('a[href^="#klaviyo-popup"]')
klaviyoPopupTriggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
        e.preventDefault();
        var triggerLink = trigger.href;
        var klaviyoPopupId = triggerLink.split("_")[1];
        console.log(klaviyoPopupId)
        openKlaviyoPopup(klaviyoPopupId)
    })
})

function openKlaviyoPopup(formId){  
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
}


function ajaxAddToCart(id, quantity){
    var items = [{
        'id':id,
        'quantity':quantity
    }];
    var formData = {  items: items }
        
    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
    })
    .then(response => { return response.json() })
    .then(data => { 
        var product = data.items[0]
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: {  product: product, }
        }));
    })
    .catch((error) => { console.error('Error:', error) }); 
};

(function addAllVariantsToCart(){
    let selectors = {
        el: '[data-add-all-variants-to-cart]'
    }

    let button = document.querySelector(selectors.el);
    console.log(button);

    if(!button) return; 

    button.addEventListener('click', (e) => {
        e.preventDefault();
        
        var items = [];
        let all_variants = JSON.parse(document.querySelector('[data-all-available-variants-json]').innerText)
        all_variants.map(itm => itm.available ? items.push({'id': itm.id, 'quantity': 1}) : null )

        if(all_variants.length == 0) return;

        var formData = {  items: items }
        console.log(formData);
            
        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        })
        .then(response => { return response.json() })
        .then(data => { 
            console.log(data.items);
            var product = data.items[0]
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                detail: {  product: product, }
            }));
        })
        .catch((error) => { console.error('Error:', error) }); 
    })
})();

(function refreshCartUpsell() {
    document.addEventListener('cart:updated', (e) => {
        updateUpsell();
    }) 
    document.addEventListener('ajaxProduct:added', (e) => {
        updateUpsell();
    });

    const updateUpsell = () => { 
        fetch(window.Shopify.routes.root + `?section_id=cart-upsell-section`)
        .then(res => res.text()) 
        .then(data => {
            document.querySelector('#CartUpsell').innerHTML = data;
            document.dispatchEvent(new CustomEvent('cartUpsellUpdated'));
            upsellPopup()
        })
    }


})();

function upsellPopup(){
    var selectors = {
        upsellTrigger: '.cart-upsell-trigger',
        cartDrawer: "#CartDrawer",
        cartDrawerUpsell: '.cart-drawer-upsell',

        productSection: '.product-section',
        variantDropdown: '.cart-upsell__variant-dropdown'
    }
    var classes = {
        upsellActive: 'upsell-active', 
        variantDropdownActive: 'active',
    }

    const cartDrawer = document.querySelector(selectors.cartDrawer);
    const upsellTrigger = document.querySelector(selectors.upsellTrigger);
    const variantDropdowns = document.querySelectorAll(selectors.variantDropdown);
    const productSections = cartDrawer.querySelectorAll(selectors.productSection);
 
    if(!upsellTrigger || !cartDrawer) {return}; 

    upsellTrigger.addEventListener('click', (e) => {
        e.stopPropagation();
        cartDrawer.classList.add(classes.upsellActive)
    })
    
    variantDropdowns.forEach(variantDropdown => {
        variantDropdown.addEventListener('click', () => {
            variantDropdown.classList.add(classes.variantDropdownActive)
        })
    })
    
    productSections.forEach(productSection => {
        productSection.addEventListener('variantChange', (e) => {
            const productSection = e.target;
            const variantDropdowns = productSection.querySelectorAll(selectors.variantDropdown);

            variantDropdowns.forEach(variantDropdown => {
                let isColor; 
                variantDropdown.dataset.isColor == "true" ? isColor = true : isColor = false;
    
                // const variantSelected = e.detail.variant.title;
                
                const variantSelected = variantDropdown.querySelector('input[type="radio"]:checked').value;

                console.log(e.detail.variant);

                if(isColor) {
                    const activeSwatch = variantDropdown.querySelector(`.variant-input[data-value="${variantSelected}"] label`);
                    const _activeSwatch = activeSwatch.cloneNode(1);
                    variantDropdown.replaceChild(_activeSwatch, variantDropdown.querySelector('.color-swatch')); 
                }

                variantDropdown.classList.remove(classes.variantDropdownActive)
                variantDropdown.querySelector('.active-option-name').innerText = variantSelected

            })
            
        })
    })  
}

upsellPopup()